import ShortKey from 'vue-three-shortkey'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ShortKey, { prevent: ['input', 'textarea'] })
})
